// @flow

import './UnusedCategoryRow.scss';

import PropTypes from 'prop-types';

import React, { Component } from 'react';
import _ from 'lodash';

import ViewConstants from 'constants/ViewConstants';

import SecurityContext from 'utils/permissions/SecurityContext';

// -- actions
import { RestaurantMenuAction, RouteAction } from 'actions';

// -- entities
import { RestaurantMenu, ProductCategory } from 'PMT/entities/menu';

// -- views
import SortableList from 'PMT/components/SortableList';
import ImageLoader from 'PMT/components/ImageLoader';

class UnusedCategoryRow extends Component {

  static propTypes = {
    category: PropTypes.instanceOf(ProductCategory).isRequired,

    restaurantMenu: PropTypes.instanceOf(RestaurantMenu).isRequired,
  };

  shouldComponentUpdate(nextProps) {
    return !nextProps.category.equals(this.props.category)
    || !nextProps.restaurantMenu.equals(this.props.restaurantMenu);
  }
  onDisplayDetail = () => {
    RouteAction.presentCategoryDetail(this.props.category);
  };

  renderImage() {
    const category:ProductCategory = this.props.category;

    return (
      <ImageLoader
        className="category_row__image"
        src={category.image}
        placeholder={ViewConstants.Image.RestaurantMenu.NO_IMAGE_FOR_CATEGORY}
        onClick={this.onDisplayDetail}
      />
    );
  }

  render(): Object {
    const category: ProductCategory = this.props.category;

    return (
      <tr className="unused_category_row pointer">
        <td
          className="hidden-xs col-sm-2"
          onClick={this.onDisplayDetail}
        >
          {this.renderImage()}
        </td>
        
        <td
          className="pointer col-xs-8 category_row__name"
          onClick={this.onDisplayDetail}
        >
          {category.name}
        </td>

      </tr>
    );
  }

}

export default UnusedCategoryRow;
